import { EnvironmentTypes } from "./enums";
import { Environment } from "./models";

export const STAGE_DOMAIN = "https://gravity-stage.rpd.cloud";
export const STAGE_MEDIA_DOMAIN = "https://gravity-stage.rpd.cloud";
export const LIVE_MEDIA_DOMAIN = "https://pg.vbet.am";
export const MULTI_STREAM_STAGE_DOMAIN = "https://gravity-stage.rpd.cloud";

const reactAppEnv = process.env.REACT_APP_ENV as EnvironmentTypes;

const multiStreamDomain =
  reactAppEnv === EnvironmentTypes.Development
    ? MULTI_STREAM_STAGE_DOMAIN
    : window.parent.location.origin;

const dev: Environment = {
  devMode: true,
  production: false,
  applicationId: 67,
  wsUrl: `${STAGE_DOMAIN}/api/signalr`,
  httpUrl: `${STAGE_DOMAIN}`,
  mediaUrl: `${STAGE_MEDIA_DOMAIN}`,
  multiStreamDomain: `${multiStreamDomain}/multy-view`,
  translationsHttpUrl: "https://rpd-translations-stage.betcoapps.com",
};

const stage: Environment = {
  devMode: false,
  production: false,
  applicationId: 67,
  wsUrl: `${STAGE_DOMAIN}/api/signalr`,
  httpUrl: `${STAGE_DOMAIN}`,
  mediaUrl: `${STAGE_MEDIA_DOMAIN}`,
  multiStreamDomain: `${multiStreamDomain}/multy-view`,
  translationsHttpUrl: "https://rpd-translations-stage.betcoapps.com",
};

const live: Environment = {
  devMode: false,
  production: true,
  applicationId: 45,
  wsUrl: `${window.location.origin}/api/signalr`,
  httpUrl: `${window.location.origin}`,
  mediaUrl: `${LIVE_MEDIA_DOMAIN}`,
  multiStreamDomain: `${multiStreamDomain}/multy-view`,
  translationsHttpUrl: `https://gravity.pascalgaming.com/translations`,
};

const envs = {
  [EnvironmentTypes.Development]: dev,
  [EnvironmentTypes.Staging]: stage,
  [EnvironmentTypes.Production]: live,
};

export const env = envs[reactAppEnv];
